import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        // UI
        this.$el = this.el
        this.$content = this.$('content')[0]
    }

    ///////////////
    // Lifecyle
    ///////////////
    destroy() {
        super.destroy();
    }

    ///////////////
    // Methods
    ///////////////
    setCartCounter(cart) {
        if (cart?.items?.length) {
            this.$el.classList.add('is-active')
            this.$content.innerHTML = `${cart.item_count}`

        } else {
            this.$el.classList.remove('is-active')
            this.$content.innerHTML = `0`
        }
    }
}
